import { Popover } from 'bootstrap';
import jsKit from './jsKit';

const getOrderForm = () => document.getElementById('ceneo_order_details');

const hideOptionPopovers = () => {
  document.querySelectorAll('[data-js-ceneo-option-popover]').forEach((trigger) => {
    Popover.getInstance(trigger)?.hide();
  });
};

const toggleCancelCeneoOrder = (e) => {
  const cancelButton = document.getElementById('cancel-ceneo');
  const saveButton = document.getElementById('save-product-options');
  const isConfirmed = e.target.checked;

  if (cancelButton) {
    cancelButton.disabled = !isConfirmed;
    cancelButton.classList.toggle('disabled', !isConfirmed);
  }

  if (saveButton) {
    saveButton.disabled = isConfirmed;
    saveButton.classList.toggle('disabled', isConfirmed);
  }
};

const selectCeneoProductOption = (e) => {
  const option = e.delegateTarget || e.currentTarget;
  const productId = option.dataset.productId;
  const optionId = option.dataset.optionId;
  const optionName = option.dataset.optionName;
  const optionBox = document.getElementById(`ceneo_attribute_option_${productId}_box`);
  const optionText = document.getElementById(`ceneo_attribute_option_${productId}_text`);
  const optionInput = document.getElementById(`ceneo_attribute_option_${productId}`);

  option.checked = true;
  option.closest('label')?.classList.add('checked');
  optionBox?.classList.remove('required-option-selection');
  optionBox?.classList.add('required-option-selection-ok');

  if (optionText) {
    optionText.textContent = optionName;
  }
  if (optionInput) {
    optionInput.value = optionId;
  }

  hideOptionPopovers();
};

const submitCeneoOrder = async (e, url) => {
  e.preventDefault();

  const form = getOrderForm();
  const trigger = e.delegateTarget || e.currentTarget;
  if (!form || !trigger) return;

  jsKit.setLoading(trigger, true, { disabled: true });
  const response = await jsKit.requestUrl(url, 'json', 'POST', new FormData(form));
  jsKit.setLoading(trigger, false, { disabled: true });

  if (response?.validated && response.reload) {
    window.location.reload();
    return;
  }

  jsKit.showErrors(response, 'body');
  if (response?.load_flash_message) {
    jsKit.loadFlashMessages(response.load_flash_message);
  }
};

const cancelCeneoOrder = (e) => {
  const trigger = e.delegateTarget || e.currentTarget;
  if (!window.confirm(trigger.dataset.jsCancelCeneoOrder)) return;

  submitCeneoOrder(e, '/order/cancelCeneoOrder/');
};

const saveCeneoOrderProductSelection = (e) => submitCeneoOrder(e, '/order/setCeneoOrderSelection/');

export const initCeneoOrder = () => {
  const popoverTriggers = document.querySelectorAll('[data-js-ceneo-option-popover]');
  if (!popoverTriggers.length) return;

  getOrderForm()?.addEventListener('submit', (e) => e.preventDefault());

  popoverTriggers.forEach((trigger) => {
    const content = trigger.closest('.product-row')?.querySelector('.stock-options')?.innerHTML;
    if (content) {
      Popover.getOrCreateInstance(trigger, { content, html: true });
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.popover, [data-js-ceneo-option-popover]')) {
      hideOptionPopovers();
    }
  });
};

export const ceneoOrderEvents = [
  ['jsToggleCancelCeneoOrder', toggleCancelCeneoOrder, 'change'],
  ['jsSelectCeneoProductOption', selectCeneoProductOption, 'change'],
  ['jsCancelCeneoOrder', cancelCeneoOrder],
  ['jsSaveCeneoOrderProductSelection', saveCeneoOrderProductSelection],
];
